import React from 'react'

const Or = () => {
  return (
    <div className='flex flex-row items-center gap-2'>
      <div className='w-full h-px rounded-sm border-b border-mediumGray' />
      <div className='text-center text-textColor text-sm font-semibold'>OR</div>
      <div className='w-full h-px rounded-sm border-b border-mediumGray' />
    </div>
  )
}

export default Or
